import { createContext } from 'react'

interface LoyaltySpendPointsPricingContextValue {
  burnPointsLimit?: number
  showOffersWithinBalance: boolean
  isSpendPointsPage: boolean
}

const LoyaltySpendPointsPricingContext = createContext<LoyaltySpendPointsPricingContextValue>({
  showOffersWithinBalance: false,
  isSpendPointsPage: false,
})

export default LoyaltySpendPointsPricingContext
